import { pushDatalayer } from '../../../datalayer'

const isLinkCTA = (link: string): { result: boolean; type: string } => {
  if (link?.startsWith('tel:')) {
    return { result: true, type: 'Telephone' }
  }

  if (link?.startsWith('mailto:')) {
    return { result: true, type: 'Email' }
  }

  if (link.includes('/contact')) {
    // Example: use the correct internal contact page path
    return { result: true, type: 'ContactPage' }
  }

  if (link.includes('en.wikipedia.org/wiki/Norway')) {
    // Example: use the correct external contact page
    return { result: true, type: 'ExternalPage' }
  }

  return { result: false, type: null }
}

export function datalayerHandler(
  type: string,
  action?: string,
  category?: string,
  blockInfo?: {
    kind?: string
    title?: string
    link?: string
    label?: string
  }
): void {
  if (window.location.pathname.includes('/styleguide')) return

  let datalayer: {
    event?: string
    category?: string
    action?: string
    label?: string
  } = {}

  if (category !== null) {
    datalayer.category = category
  }

  if (action !== null) {
    datalayer.action = action
  }

  if (
    type === 'text' ||
    type === 'text-image' ||
    type === 'cta' ||
    type === 'quote' ||
    type === 'featured' ||
    type === 'link-grid'
  ) {
    const linkType = isLinkCTA(blockInfo.link)

    if (linkType.result === false) return

    datalayer.category = 'CTA'
    datalayer.action = linkType.type
  }

  if (type === 'media') {
    datalayer.label = blockInfo.link + ' | ' + window.location.pathname
  }

  if (isEmptyObject(datalayer)) return

  pushDatalayer({
    category: datalayer.category ? datalayer.category : 'BuildingBlock',
    action: datalayer.action ? datalayer.action : 'Click'
  })
}

const isEmptyObject = <a>(x: a): boolean => Object.keys(x).length <= 0
